// Get DOM Elements
const slider = <HTMLDivElement>document.getElementById('savingSlider');
const valueDisplay = <HTMLSpanElement>document.getElementById('savingSliderValue');
const savingItems = <NodeListOf<HTMLDivElement>>document.querySelectorAll('.saving__item');

// Get values for position caluclation
const limit = {
  min: parseInt(slider.getAttribute('min'), 10),
  max: parseInt(slider.getAttribute('max'), 10),
};

function monthParser(value: number): string {
  if (value === 0) {
    return 'Direct';
  }
  if (value >= 12) {
    const year = Math.floor(value / 12);
    return `${year} jaar`;
  }

  return `${value} maanden`;
}

// Handle sliding
function handleSlider(event: Event) {
  // Get target and cast as input
  const target = event.target as HTMLInputElement;
  // Get current value
  const { value } = target;

  // Calculate the position of the handle
  const percentage = (parseInt(value, 10) - limit.min) / (limit.max - limit.min);
  const position = slider.offsetWidth * percentage;

  // Set value tracker to position of handle
  valueDisplay.style.transform = `translateX(calc(${position}px - 50%)) translateY(100%)`;
  valueDisplay.innerText = monthParser(Math.floor(parseInt(value, 10)));

  savingItems.forEach((item: HTMLDivElement) => {
    if (parseInt(item.dataset.time, 10) <= parseInt(value, 10)) {
      item.dataset.active = 'true';
    } else {
      item.dataset.active = 'false';
    }
  });
}

function startSliding() {
  slider.addEventListener('mousemove', handleSlider, false);
  valueDisplay.dataset.active = 'true';
}

function endSliding() {
  slider.removeEventListener('mousemove', handleSlider);
  valueDisplay.dataset.active = 'false';
}

// Initialize the slider
function initSavingSlider() {
  // Add change event listener to slider
  slider.addEventListener('mousedown', startSliding);
  window.addEventListener('mouseup', endSliding);
}

// If slider exists,
// Initialize
if (slider) {
  initSavingSlider();
}
